import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { PopoverConfig } from './config';
import { TemplatePortal } from '@angular/cdk/portal';
import { OverlayRef, Overlay, OverlayConfig } from '@angular/cdk/overlay';

@Component({
  selector: 'travel-ui-pop-over',
  templateUrl: './pop-over.component.html',
  styleUrls: ['./pop-over.component.scss']
})
export class PopOverComponent implements OnInit {
  overlayConfig: any;
  @ViewChild('policy', { static: true }) policy: TemplatePortal<any> | undefined;
  @Input() config!: PopoverConfig['config'];
  overlayRef!: OverlayRef;
  content: any;
  @Input()
  set popoverContent(data: PopoverConfig['data']) { }
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  @Output() closePopover: EventEmitter<any> = new EventEmitter<any>();
  constructor(private overlay: Overlay) {
    this.openOverlay({ showPopover: true });
  }

  ngOnInit() { }

  openOverlay(data: any) {
    this.content = data;
    // console.log(this.content);
    this.overlayConfig = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
      width: '750px',
      height: '350px'
    });
    if (
      window.innerWidth < 480 ||
      (window.innerWidth >= 480 && window.innerWidth < 640)
    ) {
      this.overlayConfig.width = '350px';
    }

    if (data.showPopover) {
      this.overlayRef = this.overlay.create(this.overlayConfig);
      this.overlayRef.attach(this.policy);
    }
  }

  closeOverlay() {
    this.overlayRef.detach();
  }

  emitAction(event: any) {
    if (event === 'cancel') {
      this.closePopover.emit();
    } else {
      this.action.emit(event);
    }
    this.closeOverlay();
  }
}
